import React,{useState} from 'react';
import Home from './view/pages/dashboard/Home';
import "./App.css";
import { BrowserRouter, Routes,Route } from 'react-router-dom';
import Login from './view/pages/login/Login';
import DashboardLayout from './view/components/DashboardLayout/DashboardLayout';
import Dashboard from './view/pages/dashboard/Dashboard';
import LiveTracking from './view/pages/dashboard/LiveTracking'
import AccessControl from './view/pages/dashboard/AccessControl'
import BannerItems from './view/pages/dashboard/BannerItems'
import Brands from './view/pages/dashboard/Brands'
import Categories from './view/pages/dashboard/Categories'
import CmsPages from './view/pages/dashboard/CmsPages'
import Coupons from './view/pages/dashboard/Coupons'
import Drivers from './view/pages/dashboard/Drivers'
import EmailTemplates from './view/pages/dashboard/EmailTemplates'
import ItemAttribute from './view/pages/dashboard/ItemAttribute'
import Items from './view/pages/dashboard/Items'
import Notifications from './view/pages/dashboard/Notifications'
import Orders from './view/pages/dashboard/Orders'
import Payments from './view/pages/dashboard/Payments'
import SalesReport from './view/pages/dashboard/SalesReport'
import Settings from './view/pages/dashboard/Settings'
import UsersCustomer from './view/pages/dashboard/UsersCustomer'
import CreateCategory from './view/pages/dashboard/CreateCategory';
import CreateBrand from './view/pages/dashboard/CreateBrands';
import CreateItem from './view/pages/dashboard/CreateItem';
import CreateItemAttribute from './view/pages/dashboard/CreateItemAttribute';
import { ToastContainer } from 'react-toastify';
import PrivateRoute from './view/components/PrivateRoutes/PrivateRoutes';
import EditCategory from './view/pages/dashboard/EditCategory';
import EditBrand from './view/pages/dashboard/EditBrand';
import EditItem from './view/pages/dashboard/EditItem';
import EditProfile from './view/pages/dashboard/EditProfile';
import EditUser from './view/pages/dashboard/EditUser';
import ViewUser from './view/pages/dashboard/ViewUser';
import ViewOrder from './view/pages/dashboard/ViewOrder';
import ViewWallet from './view/pages/dashboard/ViewWallet';
import PendingDriverAllocation from './view/pages/dashboard/PendingDriverAllocation';
import EditItemAttribute from './view/pages/dashboard/EditItemAttribute';
import CreateDriver from './view/pages/dashboard/CreateDriver';
import RequestNotificationPermission from './view/components/firebase/RequestNotificationPermission'
import { messaging } from './view/components/firebase/Firebase'; 
import { onMessage } from 'firebase/messaging';
import NotificationModal from './view/components/Notifications/Notify';



const App = () => {
  
  const [notification, setNotification] = useState(null);

  onMessage(messaging, (payload) => {
    console.log('Message received. ', payload);
    setNotification(payload.notification); 
  });


  const closeModal = () => {
    setNotification(null);
  };
  
  // Fetch the config file and store it in a global variable for the service worker
fetch('/config.json')
.then((response) => response.json())
.then((config) => {
  // Set the Firebase config globally so the service worker can access it
  window.firebaseConfig = config;

  // Register the service worker
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.register('/firebase-messaging-sw.js').then((registration) => {
      console.log('Service Worker registered with scope:', registration.scope);
    }).catch((err) => {
      console.error('Service Worker registration failed:', err);
    });
  }
})
.catch((error) => {
  console.error('Error loading Firebase config:', error);
});
  
  return (
    <>
    <ToastContainer />
     <BrowserRouter>
     <Routes>
     <Route path="/login" element={<Login />} />
      {/* Private Routes */}
      <Route path="/" element={<PrivateRoute />}>
     <Route path="/" element={<DashboardLayout />}>
     
          <Route index element={<Home />} />
          {/* Other routes can go here */}
     <Route path='/dashboard' element={<Dashboard />} />
     <Route path='/live-tracking' element={<LiveTracking />} />
     <Route path='/access-control' element={<AccessControl />} />
     <Route path='/users-customer' element={<UsersCustomer />} />
     <Route path='/drivers' element={<Drivers />} />
     <Route path='/sales-report' element={<SalesReport />} />
     <Route path='/categories' element={<Categories />} />
     <Route path='/brands' element={<Brands />} />
     <Route path='/items' element={<Items />} />
     <Route path='/item-attribute' element={<ItemAttribute />} />
     <Route path='/orders' element={<Orders />} />
     <Route path='/coupons' element={<Coupons />} />
     <Route path='/notifications' element={<Notifications />} />
     <Route path='/payments' element={<Payments />} />
     <Route path='/banner-items' element={<BannerItems />} />
     <Route path='/email-templates' element={<EmailTemplates />} />
     <Route path='/cms-pages' element={<CmsPages />} />
     <Route path='/settings' element={<Settings />} />
     <Route path='/categories/create' element={<CreateCategory />} />
     <Route path='/brands/create' element={<CreateBrand />} />
     <Route path='/items/create' element={<CreateItem />} />
     <Route path='/item-attribute/create' element={<CreateItemAttribute />} />
     <Route path="/categories/edit/:id" element={<EditCategory />}  />
     <Route path="/brands/edit/:id" element={<EditBrand />}  />
     <Route path="/items/edit/:id" element={<EditItem />}  />
     <Route path="/users/profile" element={<EditProfile />}  />
     <Route path="/users-customer/edit/:id" element={<EditUser />}  />
     <Route path="/users-customer/view/:id" element={<ViewUser />}  />
     <Route path="/order/:id" element={<ViewOrder />}  />
     <Route path="/wallet-transaction/:id" element={<ViewWallet />}  />
     <Route path="/pending-driver-allocation" element={<PendingDriverAllocation />}  />
     <Route path="/item-attribute/edit/:id" element={<EditItemAttribute />}  />
     <Route path="/drivers/create" element={<CreateDriver />}  />
     {/* <Route path="/msg" element={<RequestNotificationPermission />}  /> */}
     </Route>
     </Route>
     </Routes>
     {notification && (
                <NotificationModal notification={notification} onClose={closeModal} />
              )}


     </BrowserRouter>
    </>
  );
};

export default App;